import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails"; // Import Turbo

// Connects to data-controller="chat-read"
export default class extends Controller {
  static values = { roomId: Number };

  connect() {
    this.markMessagesAsRead();
  }

  markMessagesAsRead() {
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    fetch(`/rooms/${this.roomIdValue}/mark_as_read`, {
      method: "POST",
      headers: {
        // Tell Rails we want a Turbo Stream response
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token": csrfToken,
      },
    })
      .then((response) => response.text())
      .then((html) => {
        // Tell Turbo to execute the stream!
        Turbo.renderStreamMessage(html);
      });
  }
}
